import { h, JSX } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { isString } from "../../../../shared/utility/helper";
import { isAnimating } from "../../../../shared/services/routing-manager";

export const SideDrawerContent = ({
  activeRoutingKey,
  locale,
  backButtonText,
  onClickBack,
}: {
  activeRoutingKey: string;
  locale: string;
  backButtonText: string;
  onClickBack: () => void;
}): JSX.Element => (
  <div class="drawer-content">
    <span class="first-focus" tabIndex={-1} />

    <div class="side-drawer-header">
      {isString(backButtonText) && !isAnimating() ? (
        <phn-nd-back-button
          class="back-button"
          onClick={onClickBack}
          text={backButtonText}
          analyticsId={navContentStore.state.menu.id}
        />
      ) : null}
    </div>

    <phn-nd-side-drawer activeRoutingKey={activeRoutingKey} locale={locale} />
  </div>
);
